import React from 'react';
import { ToastContainer as ToasterRoot, Slide } from 'react-toastify';
import styled from 'styled-components';
import check from 'images/check.svg';
import warning from 'images/warning.svg';
import error from 'images/error.svg';

const ToasterWrapper = styled.div`
  .toaster {
    background-color: #fff;
    color: #00194d;
    text-align: left;
    font-family: Roboto, Arial, sans-serif;
    font-weight: bold;
    font-size: 14px;
    letter-spacing: -0.15px;
    box-shadow: 0px 6px 16px #0000001f;
    border: 0.5px solid #d2d5dc;
    border-radius: 4px;
  }
  .Toastify__toast-container {
    width: 380px;
  }
  .Toastify__toast {
    height: 80px;
    width: 100%;
    background-repeat: no-repeat;
    background-position: 18px 22px;
  }
  .Toastify__toast--error {
    background-image: url(${error});
  }
  .Toastify__toast--success {
    background-image: url(${check});
  }
  .Toastify__toast--warning {
    background-image: url(${warning});
  }
  .Toastify__toast-body {
    padding: 5px;
    margin-left: 39px;
    position: relative;
    top: -8px;
  }
  .Toastify__close-button {
    color: #00194d;
    position: relative;
    top: 15px;
    right: 15px;
  }
`;

export const Toaster = () => {
  return (
    <ToasterWrapper>
      <ToasterRoot
        containerId="app-bawaba-toaster"
        autoClose={3000}
        draggable={false}
        position="bottom-right"
        hideProgressBar
        limit={5}
        toastClassName="toaster"
        transition={Slide}
        pauseOnFocusLoss
        pauseOnHover
      />
    </ToasterWrapper>
  );
};

export default Toaster;
